import { Typography } from '@mui/material';
import * as React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    h1: {
        fontSize: "28pt",
        textAlign: "center"
    },

    h2: {
        fontSize: "24pt",
        textAlign: "left"
    },

    h3: {
        fontSize: "20pt",
        textAlign: "left"
    },

    h4: {
        fontSize: "18pt",
        textAlign: "left"
    },
      
          
  }));

export function H1(props){
    const classes = useStyles();
    return <Typography variant="h1" className={classes.h1}>{props.children}</Typography>
}

export function H2(props){
    const classes = useStyles();
    return <Typography variant="h2" className={classes.h2}>{props.children}</Typography>
}

export function H3(props){
    const classes = useStyles();
    return <Typography variant="h3" mt="2" mb="2" className={classes.h3}>{props.children}</Typography>
}

export function H4(props){
    const classes = useStyles();
    return <Typography variant="h4" className={classes.h4}>{props.children}</Typography>
}

  
